// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductReport_productTextBackGround__bJtFa {
  border: 1px solid black !important;
  margin: 1rem;
  background-color: var(--secondary-color);
}
.ProductReport_tableHeadingColor__Xb6XT {
  background-color: var(--disabled-color) !important;
}

.ProductReport_productText__W5ERX {
  color: var(--heading-color);
  font-size: 30px !important;
  font-weight: 600 !important;
}

.ProductReport_siteAndCampaign__Vw70y {
  color: var(--heading-color);
  font-size: 18px !important;
  font-weight: 600 !important;
}

.ProductReport_productSiteCampaignInfo__e8LWM {
  font-size: 16px !important;
  font-weight: 300;
  color: var(--heading-color) !important;
}
.ProductReport_reccePartner__UIB8V {
  color: var(--heading-color);
  font-weight: 600 !important;
  font-size: 16px !important;
}

.ProductReport_productServiceLocation__c2GJe {
  color: var(--heading-color);
  padding-left: 2rem;
  font-weight: 600 !important;
  font-size: 16px !important;
}

.ProductReport_product__\\+0vPG {
  color: var(--heading-color);
  padding-left: 0.5rem;
  font-weight: 600 !important;
  font-size: 18px !important;
}
.ProductReport_productServiceLocationContent__UqGfq {
  color: var(--heading-color);
  font-size: 17px !important;
}

.ProductReport_secondContainer__FrBbA {
  background-color: var(--secondary-color);
  padding-top: 0.7rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-top-left-radius: 4rem;
  border-top-right-radius: 4rem;
}

.ProductReport_recceReport__ExFzl {
  font-size: 28px !important;
  font-weight: 900;
  color: var(--heading-color);
  margin-bottom: 20px !important;
}

.ProductReport_tableCellHeading__i-fke {
  background-color: var(--heading-color) !important;
  color: var(--secondary-color) !important;
  font-size: 15px !important;
  font-weight: 500 !important ;
  white-space: nowrap;
  border: 1px solid #ccc !important;
  /* height: 30px !important; */
  /* line-height: 24px !important; */
  /* padding: 1px 16px !important; */
  padding-bottom: 10px !important;
  padding-top: 0px !important;
  margin-bottom: 15px;
}
.ProductReport_headingContent__I\\+Qwq {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: var(--para-color) !important;
}

.ProductReport_totalPreviousImprovisedContent__gkXeK {
  font-size: 16px !important;
  font-weight: 300 !important;
  color: var(--heading-color) !important;
  text-align: left !important;
  border: 1px solid #ccc;
  line-height: 30px !important;
  padding-bottom: 10px !important;
  padding-top: 0px !important;
  margin-bottom: 20px;
  margin-top: 0px;
}

.ProductReport_dividerComponent__mTQQ2 {
  margin-bottom: 0.3rem !important;
  margin-top: 0.3rem !important;
  border-width: 1px !important;
  border-color: var(--para-color) !important;
}

.ProductReport_imageLogo__wLcgX {
  width: 100% !important;
  height: auto !important;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.ProductReport_custom-dialog__TTPDJ {
  background-color: lightblue;
  border-radius: 12px;
}

.ProductReport_iconButton__abrUp {
  position: absolute !important;
  right: 2rem;

  top: 15px;
  font-weight: bold;
  background-color: black !important;
  color: white !important;
  border: none;
  padding: 2px !important;
}

.ProductReport_label__XnVMw {
  padding-left: 0.5rem !important;
}

.ProductReport_border__XkN0Y {
  border: 1px solid black !important;
}

.ProductReport_reccePartnerStyling__OhS4Q {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
}

.ProductReport_ReceePartnerImageSection__Tdal1 {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  line-height: 2px !important;
  gap: 0px !important;
}

.ProductReport_profileImageWithIp__Rraoh {
  display: "flex";
  justify-content: start;
  margin-bottom: 1rem !important;
  margin-top: 1rem !important;
}

.ProductReport_tableWithBorder__WZTMu {
  border: 1px solid #ccc !important;
  border-collapse: collapse !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/RFPDashboard/RecceApproval/ProductReport.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,iDAAiD;EACjD,wCAAwC;EACxC,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,sCAAsC;EACtC,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;;EAEX,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC","sourcesContent":[".productTextBackGround {\n  border: 1px solid black !important;\n  margin: 1rem;\n  background-color: var(--secondary-color);\n}\n.tableHeadingColor {\n  background-color: var(--disabled-color) !important;\n}\n\n.productText {\n  color: var(--heading-color);\n  font-size: 30px !important;\n  font-weight: 600 !important;\n}\n\n.siteAndCampaign {\n  color: var(--heading-color);\n  font-size: 18px !important;\n  font-weight: 600 !important;\n}\n\n.productSiteCampaignInfo {\n  font-size: 16px !important;\n  font-weight: 300;\n  color: var(--heading-color) !important;\n}\n.reccePartner {\n  color: var(--heading-color);\n  font-weight: 600 !important;\n  font-size: 16px !important;\n}\n\n.productServiceLocation {\n  color: var(--heading-color);\n  padding-left: 2rem;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n}\n\n.product {\n  color: var(--heading-color);\n  padding-left: 0.5rem;\n  font-weight: 600 !important;\n  font-size: 18px !important;\n}\n.productServiceLocationContent {\n  color: var(--heading-color);\n  font-size: 17px !important;\n}\n\n.secondContainer {\n  background-color: var(--secondary-color);\n  padding-top: 0.7rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border-top-left-radius: 4rem;\n  border-top-right-radius: 4rem;\n}\n\n.recceReport {\n  margin-bottom: 20px;\n  font-size: 28px !important;\n  font-weight: 900;\n  color: var(--heading-color);\n  margin-bottom: 20px !important;\n}\n\n.tableCellHeading {\n  background-color: var(--heading-color) !important;\n  color: var(--secondary-color) !important;\n  font-size: 15px !important;\n  font-weight: 500 !important ;\n  white-space: nowrap;\n  border: 1px solid #ccc !important;\n  /* height: 30px !important; */\n  /* line-height: 24px !important; */\n  /* padding: 1px 16px !important; */\n  padding-bottom: 10px !important;\n  padding-top: 0px !important;\n  margin-bottom: 15px;\n}\n.headingContent {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: var(--para-color) !important;\n}\n\n.totalPreviousImprovisedContent {\n  font-size: 16px !important;\n  font-weight: 300 !important;\n  color: var(--heading-color) !important;\n  text-align: left !important;\n  border: 1px solid #ccc;\n  line-height: 30px !important;\n  padding-bottom: 10px !important;\n  padding-top: 0px !important;\n  margin-bottom: 20px;\n  margin-top: 0px;\n}\n\n.dividerComponent {\n  margin-bottom: 0.3rem !important;\n  margin-top: 0.3rem !important;\n  border-width: 1px !important;\n  border-color: var(--para-color) !important;\n}\n\n.imageLogo {\n  width: 100% !important;\n  height: auto !important;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;\n}\n\n.custom-dialog {\n  background-color: lightblue;\n  border-radius: 12px;\n}\n\n.iconButton {\n  position: absolute !important;\n  right: 2rem;\n\n  top: 15px;\n  font-weight: bold;\n  background-color: black !important;\n  color: white !important;\n  border: none;\n  padding: 2px !important;\n}\n\n.label {\n  padding-left: 0.5rem !important;\n}\n\n.border {\n  border: 1px solid black !important;\n}\n\n.reccePartnerStyling {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: start;\n}\n\n.ReceePartnerImageSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n  line-height: 2px !important;\n  gap: 0px !important;\n}\n\n.profileImageWithIp {\n  display: \"flex\";\n  justify-content: start;\n  margin-bottom: 1rem !important;\n  margin-top: 1rem !important;\n}\n\n.tableWithBorder {\n  border: 1px solid #ccc !important;\n  border-collapse: collapse !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productTextBackGround": `ProductReport_productTextBackGround__bJtFa`,
	"tableHeadingColor": `ProductReport_tableHeadingColor__Xb6XT`,
	"productText": `ProductReport_productText__W5ERX`,
	"siteAndCampaign": `ProductReport_siteAndCampaign__Vw70y`,
	"productSiteCampaignInfo": `ProductReport_productSiteCampaignInfo__e8LWM`,
	"reccePartner": `ProductReport_reccePartner__UIB8V`,
	"productServiceLocation": `ProductReport_productServiceLocation__c2GJe`,
	"product": `ProductReport_product__+0vPG`,
	"productServiceLocationContent": `ProductReport_productServiceLocationContent__UqGfq`,
	"secondContainer": `ProductReport_secondContainer__FrBbA`,
	"recceReport": `ProductReport_recceReport__ExFzl`,
	"tableCellHeading": `ProductReport_tableCellHeading__i-fke`,
	"headingContent": `ProductReport_headingContent__I+Qwq`,
	"totalPreviousImprovisedContent": `ProductReport_totalPreviousImprovisedContent__gkXeK`,
	"dividerComponent": `ProductReport_dividerComponent__mTQQ2`,
	"imageLogo": `ProductReport_imageLogo__wLcgX`,
	"custom-dialog": `ProductReport_custom-dialog__TTPDJ`,
	"iconButton": `ProductReport_iconButton__abrUp`,
	"label": `ProductReport_label__XnVMw`,
	"border": `ProductReport_border__XkN0Y`,
	"reccePartnerStyling": `ProductReport_reccePartnerStyling__OhS4Q`,
	"ReceePartnerImageSection": `ProductReport_ReceePartnerImageSection__Tdal1`,
	"profileImageWithIp": `ProductReport_profileImageWithIp__Rraoh`,
	"tableWithBorder": `ProductReport_tableWithBorder__WZTMu`
};
export default ___CSS_LOADER_EXPORT___;
